import type { PropsWithChildren } from 'react'
import type { TestIds } from '../../../../utils/testing.ts'
import { Text } from '../../../text/text.tsx'

export type CardHeadingDescriptionProps = PropsWithChildren<
  TestIds & { className?: string }
>

export const CardHeadingDescription = ({
  children,
  className,
  ...testIds
}: CardHeadingDescriptionProps) => (
  <Text fontSize="sm" textColor="secondary" className={className} {...testIds}>
    {children}
  </Text>
)
